import Swiper from 'swiper'
import forEach from 'lodash/forEach'

export default function slider() {
  let index = 0

  forEach(document.querySelectorAll('.carousel-generic .swiper-container'), (container) => {
    const id = `swiper-generic-${(index += 1)}`
    const delay = parseInt(container.getAttribute('data-swiper-autoplay'), 10)

    container.setAttribute('id', id)

    /* eslint-disable */
    const swiper = new Swiper('.carousel-generic .swiper-container', {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      disableOnInteraction: true,
      autoplay: {
        delay: !isNaN(delay) ? delay : (1000 * 10)
      },
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '.button-nav--next',
        prevEl: '.button-nav--prev',
      },
      threshold: 10,
      pagination: {
        el: '.carousel-generic .swiper-pagination',
        clickable: false,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide'
      }
    })
    const slides = container.querySelectorAll('.swiper-slide')
    for (let index = 0; index < slides.length; index++) {
      const element = slides[index]
      element.getElementsByClassName('sr-only')[0].innerHTML+=` ${parseInt(element.getAttribute('data-swiper-slide-index'), 10)+1}`
      element.addEventListener('focus', function () {
        swiper.autoplay.stop()
      })
    }
    /* eslint-enable */
  })
}
